import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom';



// import AiMlSection_1 from './component/AiMlSection_1';
// import AIMlSection_1 from './component/AiMlSection_1';

import AiMlSection1 from './component/AiMlSection1';
import { AiArtificialIntelligence } from './component/AiArtificialIntelligence';
import { AiMachineLearning } from './component/AiMachineLearning';
import { AiDomainExpertise } from './component/AiDomainExpertise';

const AiMlServices = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                const elementTop = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementTop - 100,
                    behavior: 'smooth'
                });
            }
        }
        else{
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [location]);
    return (
        <>
            <section className="hero-area hero-area-background">
                <AiMlSection1 />
            </section>
            <section className='mt-20'>
                <div className="container">
                    <div id="artificial-intelligence">
                        <AiArtificialIntelligence/>
                    </div>
                    <div id="machine-learning">
                        <AiMachineLearning/>
                    </div>
                    <div id="domain-expertise">
                        <AiDomainExpertise/>
                    </div>
                </div>
            </section>
        </>
    )
}

export {AiMlServices}